function cov_n2kaemj9i() {
    var path = "/opt/buildhome/repo/packages/kg-portal/src/js/components/global/Navigation.tsx";
    var hash = "29229a10aef5d05ce6f3ef4c6847e14d85446e80";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/opt/buildhome/repo/packages/kg-portal/src/js/components/global/Navigation.tsx",
        statementMap: {
            "0": {
                start: {
                    line: 24,
                    column: 20
                },
                end: {
                    line: 24,
                    column: 49
                }
            },
            "1": {
                start: {
                    line: 25,
                    column: 19
                },
                end: {
                    line: 25,
                    column: 39
                }
            },
            "2": {
                start: {
                    line: 27,
                    column: 19
                },
                end: {
                    line: 286,
                    column: 1
                }
            },
            "3": {
                start: {
                    line: 29,
                    column: 15
                },
                end: {
                    line: 29,
                    column: 31
                }
            },
            "4": {
                start: {
                    line: 30,
                    column: 18
                },
                end: {
                    line: 30,
                    column: 31
                }
            },
            "5": {
                start: {
                    line: 31,
                    column: 22
                },
                end: {
                    line: 31,
                    column: 35
                }
            },
            "6": {
                start: {
                    line: 32,
                    column: 18
                },
                end: {
                    line: 32,
                    column: 31
                }
            },
            "7": {
                start: {
                    line: 34,
                    column: 23
                },
                end: {
                    line: 36,
                    column: 2
                }
            },
            "8": {
                start: {
                    line: 37,
                    column: 35
                },
                end: {
                    line: 37,
                    column: 68
                }
            },
            "9": {
                start: {
                    line: 38,
                    column: 22
                },
                end: {
                    line: 40,
                    column: 2
                }
            },
            "10": {
                start: {
                    line: 41,
                    column: 36
                },
                end: {
                    line: 41,
                    column: 48
                }
            },
            "11": {
                start: {
                    line: 43,
                    column: 26
                },
                end: {
                    line: 43,
                    column: 72
                }
            },
            "12": {
                start: {
                    line: 45,
                    column: 21
                },
                end: {
                    line: 45,
                    column: 56
                }
            },
            "13": {
                start: {
                    line: 46,
                    column: 21
                },
                end: {
                    line: 46,
                    column: 53
                }
            },
            "14": {
                start: {
                    line: 47,
                    column: 27
                },
                end: {
                    line: 47,
                    column: 75
                }
            },
            "15": {
                start: {
                    line: 48,
                    column: 29
                },
                end: {
                    line: 48,
                    column: 86
                }
            },
            "16": {
                start: {
                    line: 49,
                    column: 25
                },
                end: {
                    line: 49,
                    column: 71
                }
            },
            "17": {
                start: {
                    line: 50,
                    column: 24
                },
                end: {
                    line: 50,
                    column: 59
                }
            },
            "18": {
                start: {
                    line: 51,
                    column: 18
                },
                end: {
                    line: 51,
                    column: 47
                }
            },
            "19": {
                start: {
                    line: 52,
                    column: 25
                },
                end: {
                    line: 52,
                    column: 61
                }
            },
            "20": {
                start: {
                    line: 54,
                    column: 25
                },
                end: {
                    line: 57,
                    column: 2
                }
            },
            "21": {
                start: {
                    line: 55,
                    column: 2
                },
                end: {
                    line: 55,
                    column: 25
                }
            },
            "22": {
                start: {
                    line: 56,
                    column: 2
                },
                end: {
                    line: 56,
                    column: 18
                }
            },
            "23": {
                start: {
                    line: 59,
                    column: 21
                },
                end: {
                    line: 74,
                    column: 2
                }
            },
            "24": {
                start: {
                    line: 60,
                    column: 36
                },
                end: {
                    line: 63,
                    column: 3
                }
            },
            "25": {
                start: {
                    line: 64,
                    column: 36
                },
                end: {
                    line: 67,
                    column: 3
                }
            },
            "26": {
                start: {
                    line: 69,
                    column: 2
                },
                end: {
                    line: 73,
                    column: 3
                }
            },
            "27": {
                start: {
                    line: 70,
                    column: 3
                },
                end: {
                    line: 70,
                    column: 31
                }
            },
            "28": {
                start: {
                    line: 72,
                    column: 3
                },
                end: {
                    line: 72,
                    column: 31
                }
            },
            "29": {
                start: {
                    line: 76,
                    column: 26
                },
                end: {
                    line: 85,
                    column: 2
                }
            },
            "30": {
                start: {
                    line: 77,
                    column: 2
                },
                end: {
                    line: 84,
                    column: 7
                }
            },
            "31": {
                start: {
                    line: 87,
                    column: 37
                },
                end: {
                    line: 98,
                    column: 2
                }
            },
            "32": {
                start: {
                    line: 90,
                    column: 2
                },
                end: {
                    line: 97,
                    column: 7
                }
            },
            "33": {
                start: {
                    line: 100,
                    column: 23
                },
                end: {
                    line: 128,
                    column: 2
                }
            },
            "34": {
                start: {
                    line: 101,
                    column: 2
                },
                end: {
                    line: 127,
                    column: 7
                }
            },
            "35": {
                start: {
                    line: 105,
                    column: 24
                },
                end: {
                    line: 105,
                    column: 65
                }
            },
            "36": {
                start: {
                    line: 133,
                    column: 30
                },
                end: {
                    line: 159,
                    column: 2
                }
            },
            "37": {
                start: {
                    line: 134,
                    column: 2
                },
                end: {
                    line: 158,
                    column: 5
                }
            },
            "38": {
                start: {
                    line: 140,
                    column: 6
                },
                end: {
                    line: 140,
                    column: 47
                }
            },
            "39": {
                start: {
                    line: 161,
                    column: 29
                },
                end: {
                    line: 170,
                    column: 2
                }
            },
            "40": {
                start: {
                    line: 162,
                    column: 2
                },
                end: {
                    line: 169,
                    column: 7
                }
            },
            "41": {
                start: {
                    line: 172,
                    column: 23
                },
                end: {
                    line: 183,
                    column: 2
                }
            },
            "42": {
                start: {
                    line: 173,
                    column: 2
                },
                end: {
                    line: 182,
                    column: 7
                }
            },
            "43": {
                start: {
                    line: 185,
                    column: 29
                },
                end: {
                    line: 194,
                    column: 2
                }
            },
            "44": {
                start: {
                    line: 186,
                    column: 2
                },
                end: {
                    line: 193,
                    column: 7
                }
            },
            "45": {
                start: {
                    line: 196,
                    column: 38
                },
                end: {
                    line: 205,
                    column: 2
                }
            },
            "46": {
                start: {
                    line: 197,
                    column: 2
                },
                end: {
                    line: 204,
                    column: 7
                }
            },
            "47": {
                start: {
                    line: 207,
                    column: 33
                },
                end: {
                    line: 230,
                    column: 2
                }
            },
            "48": {
                start: {
                    line: 208,
                    column: 2
                },
                end: {
                    line: 229,
                    column: 4
                }
            },
            "49": {
                start: {
                    line: 232,
                    column: 32
                },
                end: {
                    line: 244,
                    column: 2
                }
            },
            "50": {
                start: {
                    line: 233,
                    column: 2
                },
                end: {
                    line: 243,
                    column: 4
                }
            },
            "51": {
                start: {
                    line: 246,
                    column: 30
                },
                end: {
                    line: 267,
                    column: 2
                }
            },
            "52": {
                start: {
                    line: 247,
                    column: 2
                },
                end: {
                    line: 266,
                    column: 8
                }
            },
            "53": {
                start: {
                    line: 269,
                    column: 1
                },
                end: {
                    line: 285,
                    column: 3
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 27,
                        column: 19
                    },
                    end: {
                        line: 27,
                        column: 20
                    }
                },
                loc: {
                    start: {
                        line: 27,
                        column: 38
                    },
                    end: {
                        line: 286,
                        column: 1
                    }
                },
                line: 27
            },
            "1": {
                name: "(anonymous_1)",
                decl: {
                    start: {
                        line: 54,
                        column: 25
                    },
                    end: {
                        line: 54,
                        column: 26
                    }
                },
                loc: {
                    start: {
                        line: 54,
                        column: 56
                    },
                    end: {
                        line: 57,
                        column: 2
                    }
                },
                line: 54
            },
            "2": {
                name: "(anonymous_2)",
                decl: {
                    start: {
                        line: 59,
                        column: 21
                    },
                    end: {
                        line: 59,
                        column: 22
                    }
                },
                loc: {
                    start: {
                        line: 59,
                        column: 33
                    },
                    end: {
                        line: 74,
                        column: 2
                    }
                },
                line: 59
            },
            "3": {
                name: "(anonymous_3)",
                decl: {
                    start: {
                        line: 76,
                        column: 26
                    },
                    end: {
                        line: 76,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 77,
                        column: 2
                    },
                    end: {
                        line: 84,
                        column: 7
                    }
                },
                line: 77
            },
            "4": {
                name: "(anonymous_4)",
                decl: {
                    start: {
                        line: 87,
                        column: 37
                    },
                    end: {
                        line: 87,
                        column: 38
                    }
                },
                loc: {
                    start: {
                        line: 90,
                        column: 2
                    },
                    end: {
                        line: 97,
                        column: 7
                    }
                },
                line: 90
            },
            "5": {
                name: "(anonymous_5)",
                decl: {
                    start: {
                        line: 100,
                        column: 23
                    },
                    end: {
                        line: 100,
                        column: 24
                    }
                },
                loc: {
                    start: {
                        line: 101,
                        column: 2
                    },
                    end: {
                        line: 127,
                        column: 7
                    }
                },
                line: 101
            },
            "6": {
                name: "(anonymous_6)",
                decl: {
                    start: {
                        line: 105,
                        column: 13
                    },
                    end: {
                        line: 105,
                        column: 14
                    }
                },
                loc: {
                    start: {
                        line: 105,
                        column: 24
                    },
                    end: {
                        line: 105,
                        column: 65
                    }
                },
                line: 105
            },
            "7": {
                name: "(anonymous_7)",
                decl: {
                    start: {
                        line: 133,
                        column: 30
                    },
                    end: {
                        line: 133,
                        column: 31
                    }
                },
                loc: {
                    start: {
                        line: 134,
                        column: 2
                    },
                    end: {
                        line: 158,
                        column: 5
                    }
                },
                line: 134
            },
            "8": {
                name: "(anonymous_8)",
                decl: {
                    start: {
                        line: 139,
                        column: 14
                    },
                    end: {
                        line: 139,
                        column: 15
                    }
                },
                loc: {
                    start: {
                        line: 140,
                        column: 6
                    },
                    end: {
                        line: 140,
                        column: 47
                    }
                },
                line: 140
            },
            "9": {
                name: "(anonymous_9)",
                decl: {
                    start: {
                        line: 161,
                        column: 29
                    },
                    end: {
                        line: 161,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 162,
                        column: 2
                    },
                    end: {
                        line: 169,
                        column: 7
                    }
                },
                line: 162
            },
            "10": {
                name: "(anonymous_10)",
                decl: {
                    start: {
                        line: 172,
                        column: 23
                    },
                    end: {
                        line: 172,
                        column: 24
                    }
                },
                loc: {
                    start: {
                        line: 173,
                        column: 2
                    },
                    end: {
                        line: 182,
                        column: 7
                    }
                },
                line: 173
            },
            "11": {
                name: "(anonymous_11)",
                decl: {
                    start: {
                        line: 185,
                        column: 29
                    },
                    end: {
                        line: 185,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 186,
                        column: 2
                    },
                    end: {
                        line: 193,
                        column: 7
                    }
                },
                line: 186
            },
            "12": {
                name: "(anonymous_12)",
                decl: {
                    start: {
                        line: 196,
                        column: 38
                    },
                    end: {
                        line: 196,
                        column: 39
                    }
                },
                loc: {
                    start: {
                        line: 197,
                        column: 2
                    },
                    end: {
                        line: 204,
                        column: 7
                    }
                },
                line: 197
            },
            "13": {
                name: "(anonymous_13)",
                decl: {
                    start: {
                        line: 207,
                        column: 33
                    },
                    end: {
                        line: 207,
                        column: 34
                    }
                },
                loc: {
                    start: {
                        line: 207,
                        column: 52
                    },
                    end: {
                        line: 230,
                        column: 2
                    }
                },
                line: 207
            },
            "14": {
                name: "(anonymous_14)",
                decl: {
                    start: {
                        line: 232,
                        column: 32
                    },
                    end: {
                        line: 232,
                        column: 33
                    }
                },
                loc: {
                    start: {
                        line: 232,
                        column: 51
                    },
                    end: {
                        line: 244,
                        column: 2
                    }
                },
                line: 232
            },
            "15": {
                name: "(anonymous_15)",
                decl: {
                    start: {
                        line: 246,
                        column: 30
                    },
                    end: {
                        line: 246,
                        column: 31
                    }
                },
                loc: {
                    start: {
                        line: 247,
                        column: 2
                    },
                    end: {
                        line: 266,
                        column: 8
                    }
                },
                line: 247
            }
        },
        branchMap: {
            "0": {
                loc: {
                    start: {
                        line: 69,
                        column: 2
                    },
                    end: {
                        line: 73,
                        column: 3
                    }
                },
                type: "if",
                locations: [{
                        start: {
                            line: 69,
                            column: 2
                        },
                        end: {
                            line: 73,
                            column: 3
                        }
                    }, {
                        start: {
                            line: 71,
                            column: 9
                        },
                        end: {
                            line: 73,
                            column: 3
                        }
                    }],
                line: 69
            },
            "1": {
                loc: {
                    start: {
                        line: 121,
                        column: 6
                    },
                    end: {
                        line: 123,
                        column: 35
                    }
                },
                type: "binary-expr",
                locations: [{
                        start: {
                            line: 121,
                            column: 6
                        },
                        end: {
                            line: 121,
                            column: 22
                        }
                    }, {
                        start: {
                            line: 122,
                            column: 6
                        },
                        end: {
                            line: 122,
                            column: 15
                        }
                    }, {
                        start: {
                            line: 123,
                            column: 6
                        },
                        end: {
                            line: 123,
                            column: 35
                        }
                    }],
                line: 121
            },
            "2": {
                loc: {
                    start: {
                        line: 124,
                        column: 6
                    },
                    end: {
                        line: 124,
                        column: 63
                    }
                },
                type: "binary-expr",
                locations: [{
                        start: {
                            line: 124,
                            column: 6
                        },
                        end: {
                            line: 124,
                            column: 22
                        }
                    }, {
                        start: {
                            line: 124,
                            column: 26
                        },
                        end: {
                            line: 124,
                            column: 63
                        }
                    }],
                line: 124
            },
            "3": {
                loc: {
                    start: {
                        line: 214,
                        column: 6
                    },
                    end: {
                        line: 214,
                        column: 38
                    }
                },
                type: "binary-expr",
                locations: [{
                        start: {
                            line: 214,
                            column: 6
                        },
                        end: {
                            line: 214,
                            column: 16
                        }
                    }, {
                        start: {
                            line: 214,
                            column: 20
                        },
                        end: {
                            line: 214,
                            column: 38
                        }
                    }],
                line: 214
            },
            "4": {
                loc: {
                    start: {
                        line: 237,
                        column: 12
                    },
                    end: {
                        line: 237,
                        column: 44
                    }
                },
                type: "cond-expr",
                locations: [{
                        start: {
                            line: 237,
                            column: 28
                        },
                        end: {
                            line: 237,
                            column: 35
                        }
                    }, {
                        start: {
                            line: 237,
                            column: 38
                        },
                        end: {
                            line: 237,
                            column: 44
                        }
                    }],
                line: 237
            },
            "5": {
                loc: {
                    start: {
                        line: 252,
                        column: 5
                    },
                    end: {
                        line: 252,
                        column: 37
                    }
                },
                type: "binary-expr",
                locations: [{
                        start: {
                            line: 252,
                            column: 5
                        },
                        end: {
                            line: 252,
                            column: 15
                        }
                    }, {
                        start: {
                            line: 252,
                            column: 19
                        },
                        end: {
                            line: 252,
                            column: 37
                        }
                    }],
                line: 252
            },
            "6": {
                loc: {
                    start: {
                        line: 281,
                        column: 6
                    },
                    end: {
                        line: 281,
                        column: 45
                    }
                },
                type: "binary-expr",
                locations: [{
                        start: {
                            line: 281,
                            column: 6
                        },
                        end: {
                            line: 281,
                            column: 19
                        }
                    }, {
                        start: {
                            line: 281,
                            column: 23
                        },
                        end: {
                            line: 281,
                            column: 45
                        }
                    }],
                line: 281
            }
        },
        s: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "24": 0,
            "25": 0,
            "26": 0,
            "27": 0,
            "28": 0,
            "29": 0,
            "30": 0,
            "31": 0,
            "32": 0,
            "33": 0,
            "34": 0,
            "35": 0,
            "36": 0,
            "37": 0,
            "38": 0,
            "39": 0,
            "40": 0,
            "41": 0,
            "42": 0,
            "43": 0,
            "44": 0,
            "45": 0,
            "46": 0,
            "47": 0,
            "48": 0,
            "49": 0,
            "50": 0,
            "51": 0,
            "52": 0,
            "53": 0
        },
        f: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0
        },
        b: {
            "0": [0, 0],
            "1": [0, 0, 0],
            "2": [0, 0],
            "3": [0, 0],
            "4": [0, 0],
            "5": [0, 0],
            "6": [0, 0]
        },
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "29229a10aef5d05ce6f3ef4c6847e14d85446e80"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        cov_n2kaemj9i = function () {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_n2kaemj9i();
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { bindActionCreators } from '@reduxjs/toolkit';
import classnames from 'classnames';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import MediaQuery from 'react-responsive';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { Button } from 'vio-components';
import { DISPLAY_SIZES, ROUTES, URL } from 'vio-constants';
import { useReduxState } from 'vio-libs';
import { isMapRoute, isOrgKEXParticipant } from '../../lib';
import { hideHamburgerMenu, showHamburgerMenu } from '../../redux';
const consumerAPI = (cov_n2kaemj9i().s[0]++, vaporio === null || vaporio === void 0 ? void 0 : vaporio.consumer_api_rollout);
const edgeEvents = (cov_n2kaemj9i().s[1]++, vaporio === null || vaporio === void 0 ? void 0 : vaporio.edge_events);
cov_n2kaemj9i().s[2]++;
const Navigation = () => {
    cov_n2kaemj9i().f[0]++;
    const { t } = (cov_n2kaemj9i().s[3]++, useTranslation());
    const dispatch = (cov_n2kaemj9i().s[4]++, useDispatch());
    const { pathname } = (cov_n2kaemj9i().s[5]++, useLocation());
    const navigate = (cov_n2kaemj9i().s[6]++, useNavigate());
    const hamburgerMenu = (cov_n2kaemj9i().s[7]++, useReduxState('menus.hamburgerMenu'));
    const { manage_kex: manageKEX } = (cov_n2kaemj9i().s[8]++, useReduxState('user'));
    const organization = (cov_n2kaemj9i().s[9]++, useReduxState('organizations.organization'));
    const { slug: organizationSlug } = (cov_n2kaemj9i().s[10]++, organization);
    const isKEXParticipant = (cov_n2kaemj9i().s[11]++, isOrgKEXParticipant(organization, consumerAPI));
    const routeParams = (cov_n2kaemj9i().s[12]++, `?organization=${organizationSlug}`);
    const eventsRoute = (cov_n2kaemj9i().s[13]++, `${ROUTES.EVENTS}${routeParams}`);
    const kexCommunityRoute = (cov_n2kaemj9i().s[14]++, `${ROUTES.KEX}${ROUTES.COMMUNITY}${routeParams}`);
    const kexConnectionsRoute = (cov_n2kaemj9i().s[15]++, `${ROUTES.KEX}${ROUTES.ACTIVE_CONNECTIONS}${routeParams}`);
    const kexProfileRoute = (cov_n2kaemj9i().s[16]++, `${ROUTES.KEX}${ROUTES.PROFILE}${routeParams}`);
    const locationsRoute = (cov_n2kaemj9i().s[17]++, `${ROUTES.LOCATIONS}${routeParams}`);
    const mapRoute = (cov_n2kaemj9i().s[18]++, `${ROUTES.MAP}${routeParams}`);
    const networkingRoute = (cov_n2kaemj9i().s[19]++, `${ROUTES.NETWORKING}${routeParams}`);
    cov_n2kaemj9i().s[20]++;
    const navigateToRoute = (event, route) => {
        cov_n2kaemj9i().f[1]++;
        cov_n2kaemj9i().s[21]++;
        event.preventDefault();
        cov_n2kaemj9i().s[22]++;
        navigate(route);
    };
    cov_n2kaemj9i().s[23]++;
    const onMenuClick = () => {
        cov_n2kaemj9i().f[2]++;
        const hideHamburgerMenuDispatch = (cov_n2kaemj9i().s[24]++, bindActionCreators(hideHamburgerMenu, dispatch));
        const showHamburgerMenuDispatch = (cov_n2kaemj9i().s[25]++, bindActionCreators(showHamburgerMenu, dispatch));
        cov_n2kaemj9i().s[26]++;
        if (hamburgerMenu) {
            cov_n2kaemj9i().b[0][0]++;
            cov_n2kaemj9i().s[27]++;
            hideHamburgerMenuDispatch();
        }
        else {
            cov_n2kaemj9i().b[0][1]++;
            cov_n2kaemj9i().s[28]++;
            showHamburgerMenuDispatch();
        }
    };
    cov_n2kaemj9i().s[29]++;
    const renderEventsLink = () => {
        cov_n2kaemj9i().f[3]++;
        cov_n2kaemj9i().s[30]++;
        return React.createElement("li", null, React.createElement(NavLink, {
            className: "events-link",
            to: eventsRoute
        }, t('EVENTS')));
    };
    cov_n2kaemj9i().s[31]++;
    const renderActiveConnectionsLink = className => {
        cov_n2kaemj9i().f[4]++;
        cov_n2kaemj9i().s[32]++;
        return React.createElement("li", {
            className: className
        }, React.createElement(NavLink, {
            className: "active-connections-link",
            to: kexConnectionsRoute
        }, t('ACTIVE_CONNECTIONS')));
    };
    cov_n2kaemj9i().s[33]++;
    const renderKEXLink = () => {
        cov_n2kaemj9i().f[5]++;
        cov_n2kaemj9i().s[34]++;
        return React.createElement("li", null, React.createElement(NavLink, {
            className: "kex-link",
            to: ROUTES.KEX,
            onClick: event => {
                cov_n2kaemj9i().f[6]++;
                cov_n2kaemj9i().s[35]++;
                return navigateToRoute(event, kexCommunityRoute);
            }
        }, t('EDGE_EXCHANGE')), React.createElement("div", {
            className: "dropdown-content"
        }, React.createElement("ul", null, React.createElement("li", {
            className: "kex-li"
        }, React.createElement(NavLink, {
            className: "kex-community-link",
            to: kexCommunityRoute
        }, t('COMMUNITY'))), (cov_n2kaemj9i().b[1][0]++, isKEXParticipant) && (cov_n2kaemj9i().b[1][1]++, manageKEX) && (cov_n2kaemj9i().b[1][2]++, renderMyProfileLink('kex-li')), (cov_n2kaemj9i().b[2][0]++, isKEXParticipant) && (cov_n2kaemj9i().b[2][1]++, renderActiveConnectionsLink('kex-li')))));
    };
    cov_n2kaemj9i().s[36]++;
    const renderKEXNavMenuLink = () => {
        cov_n2kaemj9i().f[7]++;
        cov_n2kaemj9i().s[37]++;
        return React.createElement(React.Fragment, null, React.createElement("li", null, React.createElement(NavLink, {
            className: "kex-link",
            to: ROUTES.KEX,
            onClick: event => {
                cov_n2kaemj9i().f[8]++;
                cov_n2kaemj9i().s[38]++;
                return navigateToRoute(event, kexCommunityRoute);
            }
        }, t('EDGE_EXCHANGE'))), React.createElement("li", {
            className: "sub-nav-item"
        }, React.createElement(NavLink, {
            className: "kex-community-link",
            to: kexCommunityRoute
        }, t('COMMUNITY'))), renderMyProfileLink('sub-nav-item'), renderActiveConnectionsLink('sub-nav-item'));
    };
    cov_n2kaemj9i().s[39]++;
    const renderLocationsLink = () => {
        cov_n2kaemj9i().f[9]++;
        cov_n2kaemj9i().s[40]++;
        return React.createElement("li", null, React.createElement(NavLink, {
            className: "locations-link",
            to: locationsRoute
        }, t('LOCATIONS')));
    };
    cov_n2kaemj9i().s[41]++;
    const renderMapLink = () => {
        cov_n2kaemj9i().f[10]++;
        cov_n2kaemj9i().s[42]++;
        return React.createElement("li", null, React.createElement(NavLink, {
            className: classnames('map-link', {
                'pe-none': isMapRoute(pathname)
            }),
            to: mapRoute
        }, t('MAP')));
    };
    cov_n2kaemj9i().s[43]++;
    const renderMyProfileLink = className => {
        cov_n2kaemj9i().f[11]++;
        cov_n2kaemj9i().s[44]++;
        return React.createElement("li", {
            className: className
        }, React.createElement(NavLink, {
            className: "my-profile-link",
            to: kexProfileRoute
        }, t('MY_PROFILE')));
    };
    cov_n2kaemj9i().s[45]++;
    const renderNetworkingOverviewLink = () => {
        cov_n2kaemj9i().f[12]++;
        cov_n2kaemj9i().s[46]++;
        return React.createElement("li", null, React.createElement(NavLink, {
            className: "networking-overview-link",
            to: networkingRoute
        }, t('NETWORKING')));
    };
    cov_n2kaemj9i().s[47]++;
    const renderDesktopNavigation = () => {
        cov_n2kaemj9i().f[13]++;
        cov_n2kaemj9i().s[48]++;
        return React.createElement("div", {
            className: "desktop-nav"
        }, React.createElement("ul", null, renderMapLink(), renderLocationsLink(), renderNetworkingOverviewLink(), (cov_n2kaemj9i().b[3][0]++, edgeEvents) && (cov_n2kaemj9i().b[3][1]++, renderEventsLink()), renderKEXLink(), React.createElement("li", null, React.createElement("a", {
            className: "help-link",
            href: URL.HELP_AND_SUPPORT,
            target: '_blank',
            rel: "noreferrer"
        }, t('HELP')))));
    };
    cov_n2kaemj9i().s[49]++;
    const renderMobileNavigation = () => {
        cov_n2kaemj9i().f[14]++;
        cov_n2kaemj9i().s[50]++;
        return React.createElement("div", {
            className: "mobile-nav"
        }, React.createElement(Button, {
            onClick: onMenuClick
        }, React.createElement(FontAwesomeIcon, {
            icon: hamburgerMenu ? (cov_n2kaemj9i().b[4][0]++, faTimes) : (cov_n2kaemj9i().b[4][1]++, faBars),
            size: "lg",
            transform: "grow-2"
        })));
    };
    cov_n2kaemj9i().s[51]++;
    const renderNavigationMenu = () => {
        cov_n2kaemj9i().f[15]++;
        cov_n2kaemj9i().s[52]++;
        return React.createElement("div", {
            className: "nav-menu"
        }, React.createElement("ul", null, renderMapLink(), renderLocationsLink(), renderNetworkingOverviewLink(), (cov_n2kaemj9i().b[5][0]++, edgeEvents) && (cov_n2kaemj9i().b[5][1]++, renderEventsLink()), renderKEXNavMenuLink(), React.createElement("li", null, React.createElement("a", {
            className: "help-link",
            href: URL.HELP_AND_SUPPORT,
            target: '_blank',
            rel: "noreferrer"
        }, t('HELP_AND_SUPPORT')))));
    };
    cov_n2kaemj9i().s[53]++;
    return React.createElement(React.Fragment, null, React.createElement(MediaQuery, {
        query: DISPLAY_SIZES.DESKTOP
    }, React.createElement("div", {
        id: "navigation"
    }, renderDesktopNavigation())), React.createElement(MediaQuery, {
        query: DISPLAY_SIZES.MOBILE
    }, React.createElement("div", {
        id: "navigation",
        className: "mobile"
    }, renderMobileNavigation(), (cov_n2kaemj9i().b[6][0]++, hamburgerMenu) && (cov_n2kaemj9i().b[6][1]++, renderNavigationMenu()))));
};
export default Navigation;
